import { useCallback, useState } from 'react';
import ActionSheet from 'devextreme-react/action-sheet';

export interface GridRowAction<T> {
    text: string;
    disabled?: boolean;
    checkToDisable?: (data: T) => boolean;
    onActionClick: (data: T) => void;
}

interface GridRowActionButtonParameters<T = {}> {
    id: number;
    data: T;
    tableRowActions: GridRowAction<T>[];
}

export function GridRowActionButton<T>(props: GridRowActionButtonParameters<T>) {
    const { id, data, tableRowActions } = props;
    const [actionSheetVisible, set_actionSheetVisible] = useState(false);

    const showActionSheet = useCallback(() => {
        set_actionSheetVisible(true);
    }, [set_actionSheetVisible]);

    const onVisibleChange = useCallback(
        (isVisible: boolean) => {
            if (isVisible !== actionSheetVisible) {
                set_actionSheetVisible(isVisible);
            }
        },
        [set_actionSheetVisible, actionSheetVisible]
    );

    tableRowActions.forEach((action) => {
        if (!action.checkToDisable) return;

        action.disabled = action.checkToDisable(data);
    });

    return (
        <>
            <button
                id={`action-button-${id}`}
                className='gridButton'
                title='Click to see options'
                onClick={() => showActionSheet()}
            >
                ...
            </button>
            <ActionSheet
                usePopover={true}
                target={`#action-button-${id}`}
                dataSource={tableRowActions}
                visible={actionSheetVisible}
                onItemClick={(e) => e.itemData?.onActionClick(data)}
                showTitle={false}
                onVisibleChange={onVisibleChange}
            />
        </>
    );
}
